import { Container } from '@mui/material'
import { styled } from '@mui/material/styles'
import BackgroundImage from 'ui/src/assets/images/modern-geometrical-background-with-round-lines.png'

const ContainerBackground = styled('div')`
  width: 100vw;
  height: calc(100vh - 101px);
  background-image: url(${BackgroundImage});
  background-size: 100% 100%;
  padding-left: ${({ theme }) => theme.spacing(10)};
  ${props => props.theme.breakpoints.down('md')} {
    padding-left: 0;
  }
  padding-top: ${({ theme }) => theme.spacing(4)};
  overflow: hidden;
`

export { Container, ContainerBackground }

export default Container
